module.exports = __webpack_public_path__ + "img/gu.3a19af93.svg";